import { ID } from './StandartId';

export const CHECKBOX = {
  All: ID.CHECKBOX + "all",
  Partial: ID.CHECKBOX + "partial",
  Mapping: ID.CHECKBOX + "mapping",
  REMEMBER: ID.CHECKBOX + "remember",
};
